export default __webpack_public_path__ + "static/media/wish.9bc7b4dc.jpg";